import { Component } from '@angular/core';

@Component({
  selector: 'app-active-issue-table',
  templateUrl: './active-issue-table.component.html',
  styleUrls: ['./active-issue-table.component.scss'],
})
export class ActiveIssueTableComponent {}
